import { render, staticRenderFns } from "./PleitosDetalhar.vue?vue&type=template&id=3ace2f14"
import script from "./PleitosDetalhar.vue?vue&type=script&lang=js"
export * from "./PleitosDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports